import { LvfAppModule } from "../../enum/application/lvf-app-module";
import { Guid } from "../../types/guid.type";
import { IIdentityInfo, Identity } from "../identity/identity";
import { MultiStatusConfig } from "../multi-status/multi-status-config";
import { ITeamInfo, Team } from "../organization/team/team";
import { ISubDivisionInfo, SubDivision } from "../organization/sub-division";
import { ITaskInfo, Task } from "./task";
import { ITicketDeliveryInfo, TicketDelivery } from "./ticket-delivery";
import { ITicketTypeInfo, TicketType } from "./ticket-type";

export interface ITicketInfo extends ITaskInfo {
  FunctionalId?: string;
  RequesterIdentityUid?: Guid;
  RequesterTeamUid?: Guid;
  RequesterIdentity?: IIdentityInfo;
  RequesterTeam?: ITeamInfo;
  SubDivisionUid?: Guid;
  SubDivision?: ISubDivisionInfo;
  Delivery?: ITicketDeliveryInfo;
  TicketTypeUid?: Guid;
  TicketType?: ITicketTypeInfo;
}

export class Ticket extends Task {
  FunctionalId?: string;
  RequesterIdentityUid?: Guid;
  RequesterTeamUid?: Guid;
  RequesterIdentity?: Identity;
  RequesterTeam?: Team;
  SubDivisionUid?: Guid;
  SubDivision?: SubDivision;
  Delivery?: TicketDelivery;
  TicketTypeUid?: Guid;
  TicketType?: TicketType;

  CategoryConfig?: MultiStatusConfig;

  constructor(info: ITicketInfo) {
    super(info);

    this.LvfAppModule = LvfAppModule.TICKET;
    this.FunctionalId = info.FunctionalId;
    this.RequesterIdentityUid = info.RequesterIdentityUid;
    this.RequesterTeamUid = info.RequesterTeamUid;
    this.RequesterIdentity = Identity.createInstance(Identity, info.RequesterIdentity);
    this.RequesterTeam = Team.createInstance(Team, info.RequesterTeam);
    this.SubDivisionUid = info.SubDivisionUid;
    this.SubDivision = SubDivision.createInstance(SubDivision, info.SubDivision);
    this.Delivery = TicketDelivery.createInstance(TicketDelivery, info.Delivery);
    this.TicketTypeUid = info.TicketTypeUid;
    this.TicketType = TicketType.createInstance(TicketType, info.TicketType);
  }
}
